<template>
  <v-app id="app" style="">
    <v-main>
    <error class="pb-5"></error>
    </v-main>
    <v-footer padless absolute app>
            <idp-footer style="min-width: 100%;"></idp-footer>
    </v-footer>
  </v-app>
</template>

<script>
import Error from '../../components/Error.vue'
import idpFooter from '../../components/footer/Footer'
import version from '../../mixins/version'
import navigation from '../../mixins/navigation'

export default {
  name: 'app',
  mixins: [version, navigation],
  components: {
    idpFooter,
    Error
  },
  beforeMount () {
    this.$axios.post('expire').then(() => {
      this.$log.debug('logged out')
    }).catch(e => {
      this.$log.error('error logging out: ', e)
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: #666;
}
</style>
